import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Trans, translate } from 'react-i18next';
import humps from 'humps';

import IconCleaningQuality from 'assets/images/icon-cleaning-quality.svg';

import {
  Highlight,
  Info,
  Alert,
  EmptyState,
  SimpleList
} from 'components/Common';

export class NextBooking extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    booking: PropTypes.object,
    status: PropTypes.object
  };

  static defaultProps = {
    booking: null,
    status: null
  };

  renderDate() {
    return (
      <Info>
        <Info.Title>
          {this.props.t('overview.nextBooking.titles.date')}
        </Info.Title>

        <Info.Content>
          <Trans i18nKey="bookings.date">
            {{ startDate: this.props.booking.startTime }} at{' '}
            {{ startTime: this.props.booking.startTime }}
            -
            {{ endTime: this.props.booking.endTime }}
            ({{ duration: this.props.booking.duration }} hours)
          </Trans>
        </Info.Content>
      </Info>
    );
  }

  renderAddress() {
    return (
      <Info>
        <Info.Title>
          {this.props.t('overview.nextBooking.titles.address')}
        </Info.Title>

        <Info.Content>
          {this.props.booking.address.streetAddress},{' '}
          {this.props.booking.address.postcode}{' '}
          {this.props.booking.address.city}
        </Info.Content>
      </Info>
    );
  }

  renderServices() {
    return (
      <Info>
        <Info.Title>
          {this.props.t('overview.nextBooking.titles.services')}
        </Info.Title>

        <Info.Content>
          {this.props.t(
            `services.${humps.camelize(this.props.booking.service.name)}`
          )}
        </Info.Content>

        <SimpleList plus>
          {this.props.booking.selectedAdditionalServices.map(sas => (
            <SimpleList.Item key={sas.id}>
              {this.props.t(`additionalServices.${humps.camelize(sas.name)}`)}
            </SimpleList.Item>
          ))}
        </SimpleList>
      </Info>
    );
  }

  renderBooking() {
    return (
      <Highlight>
        {this.renderDate()}
        {this.renderAddress()}
        {this.renderServices()}
      </Highlight>
    );
  }

  renderEmpty() {
    return (
      <EmptyState
        icon={IconCleaningQuality}
        description={this.props.t('overview.nextBooking.empty.description')}
        cta={this.props.t('overview.nextBooking.empty.cta')}
        href="https://www.freska.fi"
      />
    );
  }

  render() {
    if (this.props.status && this.props.status.error) {
      return <Alert description={this.props.t('general.errors.default')} />;
    }

    return (
      <div>
        <h2>{this.props.t('overview.nextBooking.heading')}</h2>

        <p>{this.props.t('overview.nextBooking.description')}</p>

        {this.props.booking ? this.renderBooking() : this.renderEmpty()}
      </div>
    );
  }
}

export default translate()(NextBooking);



// WEBPACK FOOTER //
// ./src/components/NextBooking/NextBooking.js